<!-- src/views/HomePage.vue -->
<template>
  <div class="c-text-column" style="    position: relative;top: -90px;">
    <div class="c-text-between px-container c-flex-wrap" style="margin: 80px 0;">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <span class="c-mb-10">机器人示教与数据采集</span>
      
        <div class="c-text-align">
          <h1 style="font-size: 40px;font-family: 'Montserrat', sans-serif;text-align: left;">Franka GELLO 和 GELLO Duo</h1>
          <span  class="bg-chetwode-blue text-white rounded-full uppercase inline-flex items-center justify-center px-[8px] py-[3px] text-[8px] leading-[5px] lg:text-[10px] lg:leading-[8px] whitespace-nowrap">
            原型</span>
        </div>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
          Franka GELLO 和 Franka GELLO Duo 是面向 FR3 和 FR3 Duo 的遥操作设备，能够实现直接的关节级遥操作，用于机器人示教、数据采集和模仿学习工作流。提供单臂和双臂两种配置，完全开源，开箱即用。
        </span>
        <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10">
          <router-link to="/contact" class="buttonSite  c-mr-20">抢先获取</router-link>
            <a style="border: 2px solid #1b2f36;padding: 4px 30px;cursor: pointer;border-radius: 5px;" class="newBack"
           href="https://franka.de/hubfs/FrankaGELLODuo_OnePager_February2026.pdf?hsLang=en" target="_blank">下载一页简介</a>
        </div>
      </div>

      <div class="display-width c-text-align">
        <div style="aspect-ratio:  716/450;">
          <img src="@/assets/images/productsPage/260217_MFR3_Duo_Camera21_fp (1).png" style="width: 100%;aspect-ratio: 716/450;" />
        </div>
      </div>
    </div>

    <div style="background: #eff1f3;   padding-bottom: 5px;" class=" c-pdt-20">
      <div class="line-with-text px-container" id="system-image">
        <hr class="divider">
        <span class="line-text">为什么选择 Franka GELLO 和 Franka GELLO Duo</span>
        <hr class="divider">
      </div>

      <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 80px;gap: 40px;">
        <div class="display-width c-text-column ">
          <div class="c-text-justify-start">
            <h3 class="c-text-left c-mr-10">可用性与开源模型</h3>
          </div>
          <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
            Franka GELLO 和 GELLO Duo 完全开源，包括机械设计和软件栈。用户可以自行构建和修改系统，也可以使用 Franka Robotics 提供的预组装测试版本。这既能实现快速部署，也允许根据具体用例进行完全定制。
          </span>

        </div>
        <div class="display-width c-text-column ">
          <div class="c-text-justify-start">
            <h3 class="c-text-left c-mr-10">即用型遥操作系统</h3>
          </div>
          <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
           Franka GELLO 和 Franka GELLO Duo 通过 ROS 2 框架与 FR3 和 FR3 Duo 集成，实现低延迟的关节控制和夹爪驱动（Franka Hand 和 Robotiq）。借助 devcontainer 支持和结构化设置，用户可以快速安装并运行该系统，用于机器人示教和演示生成。
          </span>
        </div>
        <div class="display-width c-text-column ">
           <div class="c-text-justify-start">
            <h3 class="c-text-left c-mr-10">模仿学习与双臂操作</h3>
          </div>
          <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
            GELLO 通常用于基于学习的机器人应用中的数据采集。典型用例包括模仿学习、双臂操作任务、可变形物体处理以及协调双臂控制研究。
          </span>
        </div>
        <div class="display-width c-text-column ">
           <div class="c-text-justify-start">
            <h3 class="c-text-left c-mr-10">单臂与双臂配置</h3>
          </div>
          <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
            Franka GELLO 是用于 FR3 的单臂版本，适用于单机器人示教和数据生成。Franka GELLO Duo 将其扩展至 FR3 Duo，用于双臂遥操作和同步的双臂数据采集。两个系统共享相同的开源基础，并且也可以从 Franka Robotics 获得完全组装好的系统。
          </span>
        </div>
      </div>
    </div>
    
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">开源资源</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container c-flex-wrap" style="margin-bottom: 80px;">
      
      <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;">
        <span class="c-mb-10">社区</span>
        <h1>开源硬件与软件</h1>

        <span class="c-mt-5 c-mb-10 text-indent" style="text-align: left;">Franka GELLO 完全开源——从机械设计到软件栈。所有用于 3D 打印的 STL 文件均已公开，涵盖从底座支架到触发组件的每个结构部件。同时，ROS 2 集成可实现开箱即用的低延迟关节控制和夹爪驱动。打印硬件、使用软件栈，或将其扩展以用于新的研究应用。</span>
        <a href="https://franka.de/hubfs/Quick%20Installation%20Guide%20Franka%20GELLO%20Duo_0.5_R04040_1.1_EN.pdf?hsLang=en" class="linkTag" target="_blank">
            下载快速安装指南</a> 
        <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10">
          <!-- <router-link to="https://github.com/wuphilipp/gello_mechanical/tree/main/franka_fr3" class="buttonSite  c-mr-20">获取 3D 文件</router-link> -->
         <a class="buttonSite c-mr-20"
           href="https://github.com/wuphilipp/gello_mechanical/tree/main/franka_fr3" target="_blank">获取 3D 文件</a>
            <a style="border: 2px solid #1b2f36;padding: 4px 30px;cursor: pointer;border-radius: 5px;" class="newBack"
           href="https://github.com/wuphilipp/gello_software/tree/main/ros2" target="_blank">获取代码</a>
        </div>
      </div>
      <div class="display-width">
        <img src="@/assets/images/productsPage/250925_Gello_01_fp (1).png" alt="" style="    height: auto; max-width: 100%;    aspect-ratio: 716 / 450;">
      </div>
 
    </div>
    <a href="https://example.com/" target="_blank">
      <img src="@/assets/images/productsPage/260217_MFR3_Duo_Camera20_fp_resized (1).png" alt="" class="desktop-image">
    </a>
    <a href="https://example.com/" target="_blank">
      <img src="@/assets/images/productsPage/260217_MFR3_Duo_Camera20_fp_resized_portrait.png" alt="" class="mobile-image">
    </a>
    <div id="product-add-ons"></div>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">开发</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container c-flex-wrap">
      <div class="display-width">
        <img src="@/assets/images/productsPage/Franka_Robotics.jpg" alt="" style="    height: auto; max-width: 100%;">
      </div>

      <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;">
        <span class="c-mb-10">构建、创造、创新</span>
        <h1>在 Franka 机器人平台上开发 </h1>

        <span class="c-mt-5 c-mb-10 text-indent" style="text-align: left;">Franka Research 3的机器人系统包括机械臂及其控制箱。
          面向 Franka Research 3 机器人平台开发者的资源中心。深入了解丰富的工具、库和文档，助力加速您的开发之旅。无论您是经验丰富的开发者，还是刚刚起步，都能在这里找到构建、创造和创新所需的一切。</span>
        <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10">
          <div class="buttonSite">
            <!-- documents -->
            <!-- <a href="/#/resources" target="_blank">获取资料</a> -->
            <a href="/#/develop" target="_blank">了解更多</a>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="c-text-column c-text-both action-height px-container" 
            style="align-items: flex-start; justify-content: center;">
            <h2 class="c-zIndex-2">对我们的产品感兴趣吗？</h2>
            <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10 c-zIndex-2"> 
                  <router-link to="/contact" class="buttonSite">联系我们</router-link> 
            </div>
            <div style="position: absolute;right: 0;height: 100%;"> 
              <img src="@/assets/images/productsPage/FR3 move new 6.png" alt=""
              style="    height: 100%; max-width: 100%;">
            </div> 
        </div> -->

  </div>
</template>

<script>

import backgroundImage from "@/assets/images/productsPage/FR3 move new 6.png";
export default {
  metaInfo() {
    return {
      title: this.$route.meta.title, // 从路由获取标题
      meta: [
        {
          name: 'keywords',
          content: this.$route.meta.metaTags[0]['content']
        }
      ]
    }
  },
  name: 'HomePage',
  data() {
    return {
      activeIndex: 0,
      carouselInterval: null,
      isTransitioning: false,
      images: [
        { src: require('@/assets/images/productsPage/Screenshot 2026-04-09 at 14.27.36 (1).png'), alt: 'Franka Robotics产品图片1' },
        { src: require('@/assets/images/productsPage/Screenshot 2026-04-09 at 14.24.05.png'), alt: 'Franka Robotics产品图片2' },
        { src: require('@/assets/images/productsPage/Screenshot 2026-04-09 at 14.21.11.png'), alt: 'Franka Robotics产品图片3' },
        { src: require('@/assets/images/productsPage/Screenshot 2026-04-09 at 14.25.59.png'), alt: 'Franka Robotics产品图片4' },
        { src: require('@/assets/images/productsPage/260217_MFR3_Duo_Camera18_03_fp_resized.png'), alt: 'Franka Robotics产品图片5' },
         
      ],
      iframe1: '2',
      iframe2: '2',
      backgroundImage: backgroundImage,
      tableData: [
        { name: '基于工作流的应用程序编程', DESK: true, RIDE: false, FCI: false },
        { name: '快速原型设计实验和演示 ', DESK: true, RIDE: false, FCI: false },
        { name: '执行机器人任务', DESK: true, RIDE: false, FCI: true },
        { name: '开发自定义应用程序', DESK: false, RIDE: true, FCI: false },
        { name: '连接第三方硬件', DESK: false, RIDE: true, FCI: true },
        { name: '连接外部资源', DESK: false, RIDE: true, FCI: true },
        { name: '1 kHz 力矩、位置和速度控制 ', DESK: false, RIDE: false, FCI: true },
        { name: '1 kHz 传感器信号和机器人状态的测量', DESK: false, RIDE: false, FCI: true },
        { name: '访问机器人运动学和动力学模型', DESK: false, RIDE: false, FCI: true },
        { name: '与ROS和MATLAB & Simulink的集成', DESK: false, RIDE: false, FCI: true },
      ]
    }

  },
  mounted() {
    this.startCarousel();
  },
  beforeUnmount() {
    clearInterval(this.carouselInterval);
  },
  methods: {
    startCarousel() {
      this.carouselInterval = setInterval(() => {
        this.nextSlide();
      }, 5000);
    },
    nextSlide() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;

      this.activeIndex = (this.activeIndex + 1) % this.images.length;

      setTimeout(() => {
        this.isTransitioning = false;
      }, 500); // 与过渡时间保持一致
    },
    prevSlide() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;

      this.activeIndex = (this.activeIndex - 1 + this.images.length) % this.images.length;

      setTimeout(() => {
        this.isTransitioning = false;
      }, 500);
    },
    goToSlide(index) {
      if (this.isTransitioning || index === this.activeIndex) return;
      this.isTransitioning = true;

      this.activeIndex = index;

      setTimeout(() => {
        this.isTransitioning = false;
      }, 500);
    },
    pauseCarousel() {
      clearInterval(this.carouselInterval);
    },
    resumeCarousel() {
      this.startCarousel();
    }
  }
};
</script>
<style scoped>
.newBack:hover {
  background-color: #1b2f36;
  color: white;
}

.desktop-image {
  display: block;
  width: 100%;
}

.mobile-image {
  display: none;
  width: 100%;
}

@media (max-width: 999px) {
  .desktop-image {
    display: none;
  }
  .mobile-image {
    display: block;
  }
}

/* 新增轮播图样式 - 水平滑动效果 */
.carousel-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.carousel {
  position: relative;
  width: 100%;
  height: 100%;
}

.slides-wrapper {
  display: flex;
  height: 100%;
  transition: transform 0.5s ease;
  will-change: transform;
}

.slide {
  flex: 0 0 100%;
  min-width: 100%;
  position: relative;
}

.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0);
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease;
}

.carousel-btn:hover {
  /* background: rgba(0,0,0,0.8); */
}

.carousel-btn.prev {
  left: 15px;
}

.carousel-btn.next {
  right: 15px;
}

.carousel-indicators {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 10;
}

.carousel-indicators span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: background 0.3s ease;
}

.carousel-indicators span.active {
  background: white;
}

li::marker {
  unicode-bidi: isolate;
  font-variant-numeric: tabular-nums;
  text-transform: none;
  text-indent: 0px !important;
  text-align: start !important;
  text-align-last: start !important;
}

.flex-width {
  width: calc(100% / 7);
}

@media (max-width: 1260px) {
  .flex-width {
    width: calc(100% / 4);
  }
}

@media (max-width: 999px) {
  .flex-width {
    width: calc(100% / 3);
  }
}

@media (max-width: 747px) {
  .flex-width {
    width: calc(100% / 2);
  }
}

@media (max-width: 150px) {
  .flex-width {
    width: 100%
  }
}

.title-width {
  width: 33.33%;
}

/* 屏幕宽度小于 900px 时，一行展示 2 个 */
@media (max-width: 899px) {
  .title-width {
    width: 100%
  }
}

.action-height {
  height: 400px;
  background-color: #d5dbdc;
  position: relative;
}

.action-width {
  width: calc(33% - 40px);
}

/* 屏幕宽度小于 900px 时，一行展示 2 个 */
@media (max-width: 1029px) {
  .action-width {
    width: calc(50% - 40px);
  }

  .action-height {
    height: 200px;
    background-color: #d5dbdc;
  }
}

/* 屏幕宽度小于 600px 时，一行展示 1 个 */
@media (max-width: 599px) {
  .action-width {
    width: 100%;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  border: 1px solid black;
  padding: 5px;
  text-align: left;
}
</style>